<template>
  <span>（{{ fare_label }}：{{ fares }}）</span>
</template>

<script>
export default {
  props: {
    fareTable: {
      required: true,
      type: Object
    }
  },
  computed: {
    fare_label: function (){
      const maebashi = this.$store.getters['user/isMaebashi']
      let label = this.$t('tour_normal_fare')
      if(maebashi == true){ label = this.$t('tour_maebashi_fare')}
      return label
    },
    fares: function () {
      const a = Object.entries(this.fareTable).map(value => {
        let label
        switch(value){
          case "adult":
            label = this.$t('tour_fare_labels_adult')
            break
          case "child":
            label = this.$t('tour_fare_labels_child')
            break
          case "infant":
            label = this.$t('tour_fare_labels_infant')
            break
          case "baby":
            label = this.$t('tour_fare_labels_baby')
            break
          default:
            break

        }
        return `${label}${value}`+this.$t('tour_per_persons')
      })
      return a.join('、')
    }
  }
}
</script>
